import React from 'react';
import { connect } from 'react-redux';
import { Layout, Sidebar } from 'react-admin';
import { CustomAppBar } from './AppBar.js';
import { darkTheme, lightTheme } from './themes';
import { ReactQueryDevtools } from 'react-query/devtools';

const CustomSidebar = props => <Sidebar size={240} {...props} />;

const CustomLayout = props => (
    <>
        <Layout appBar={CustomAppBar} sidebar={CustomSidebar} {...props} />
        <ReactQueryDevtools initialIsOpen={true} />
    </>
);

export default connect(
    state => ({
        theme: state.theme === 'dark' ? darkTheme : lightTheme,
    }),
    {}
)(CustomLayout);
